export default "__VITE_ASSET__CD4ysnM5__"